<template>
  <div class="baseCard">
    <a-row
      style="width:100%"
      :gutter="20"
    >
      <a-col :span="19">
        <div class="detailCard">
          <p class="detailTitle">{{detailData.title}}</p>
          <p class="detailDate">{{detailData.publishDate}}</p>
          <p class="detailLine"></p>
          <div
            class="detailHtml"
            v-html="detailData.text"
          >
          </div>
        </div>
      </a-col>
      <a-col :span="5">
        <div class="detailList">
          <div class="detailListTop">
            <p>
              相关资讯
            </p>
          </div>
		  <!-- @click="$jumpTo('/workDetail',{id:item.id,type:type})" -->
          <div
            class="detailListItem"
            v-for="(item,index) in aboutList"
            :key="index"
            @click="jump(item.link)"
          >
            <p class="detailItemTitle"><img
                src="../../assets/img/hsz_icon_little.png"
                alt=""
              >{{item.title}}</p>
            <p class="detailItemDate">{{item.publishDate}}</p>
          </div>
        </div>
      </a-col>
    </a-row>

  </div>
</template>

<script>
import apiUrls from "@api";
export default {
  data() {
    return {
      detailData: [],
      aboutList: [],
      type: "zx",
    };
  },

  components: {},

  created() {
    this.type = this.$route.query.type;
    this.getDetail(this.$route.query.id);
    this.getAboutNews();
  },
  watch: {
    "$route.query.id": function (val) {
      this.type = this.$route.query.type;
      this.getDetail(this.$route.query.id);
      this.getAboutNews();
    },
  },

  methods: {
	  jump(url) {
	  	window.open(url, "_blank");
	  },
    getDetail(id) {
      apiUrls.getById({ id }).then((res) => {
        this.detailData = res.results.data;
        this.detailData.text = this.detailData.text.replace(
          /<img/g,
          "<img style='width:100%;height:auto;'"
        );
      });
    },
    getAboutNews() {
      // const node = this.$route.query.type == "zx" ? "zxzx_xgzx" : "mtbd_xgzx";
      apiUrls.getList({ node: 'dj_xgzx', page: 0, size: 5 }).then((res) => {
        this.aboutList = res.results.data;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.detailCard {
  border: 1px solid #d8d8d8;
  padding: 20px;
  .detailTitle {
    font-size: 18px;
    font-family: "MicrosoftYaHeiUI-Bold", "MicrosoftYaHeiUI";
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin: 10px 0px;
  }
  .detailDate {
    font-size: 14px;
    font-family: "MicrosoftYaHeiUI";
    color: #333333;
    text-align: center;
  }
  .detailLine {
    width: 100%;
    height: 1px;
    border: 1px dotted #d8d8d8;
    margin: 10px 0px 20px 0px;
  }
  .detailHtml {
    width: 100%;
    img {
      width: 100%;
    }
  }
}
.detailList {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px 20px 20px 20px;
  border: 1px solid #d8d8d8;
  .detailListTop {
    width: 100%;
    height: 100px;
    border-bottom: 1px dotted #d8d8d8;
    p {
      width: 79px;
      height: 65px;
      background: #f0f0f0;
      line-height: 100px;
      font-size: 14px;
      text-align: center;
      font-family: "MicrosoftYaHeiUI";
      color: #333333;
    }
  }
  .detailListItem {
    width: 100%;
    // height: 60px;
    border-bottom: 1px dotted #d8d8d8;
    display: flex;
    flex-direction: column;
    padding: 10px 0px;
    cursor: pointer;
    .detailItemTitle {
      font-size: 14px;
      font-family: "MicrosoftYaHeiUI";
      color: #656565;
      img {
        margin: -3px 5px 0px 0px;
      }
    }
    .detailItemDate {
      font-size: 12px;
      font-family: "MicrosoftYaHeiUI";
      color: #919191;
      text-align: right;
    }
  }
}
</style>